export default __webpack_public_path__ + "static/media/blue1-big.1911bcb6.png";